import {
  ADHD_ASSESSMENT_RESULT,
  ADHD_ASSESSMENT_EMAIL,
  ANXIETY_ASSESSMENT_EMAIL,
  ANXIETY_ASSESSMENT_RESULT,
  DEPRESSION_ASSESSMENT_RESULT,
  DEPRESSION_ASSESSMENT_EMAIL,
  WIDGET_ANXIETY_ASSESSMENT_RESULT,
  WIDGET_DEPRESSION_ASSESSMENT_RESULT,
  BIPOLAR_ASSESSMENT_RESULT,
  BIPOLAR_ASSESSMENT_EMAIL,
  WIDGET_BIPOLAR_ASSESSMENT_RESULT
} from 'constants/localStorageKey';
import { MfeConfiguration } from './mfe-configuration/index';

export const clearAssessmentData = () => {
  localStorage.removeItem(ADHD_ASSESSMENT_RESULT);
  localStorage.removeItem(ADHD_ASSESSMENT_EMAIL);
  localStorage.removeItem(ANXIETY_ASSESSMENT_RESULT);
  localStorage.removeItem(ANXIETY_ASSESSMENT_EMAIL);
  localStorage.removeItem(DEPRESSION_ASSESSMENT_RESULT);
  localStorage.removeItem(DEPRESSION_ASSESSMENT_EMAIL);
  localStorage.removeItem(BIPOLAR_ASSESSMENT_RESULT);
  localStorage.removeItem(BIPOLAR_ASSESSMENT_EMAIL);
};

export const clearWidgetAssessmentData = () => {
  localStorage.removeItem(WIDGET_ANXIETY_ASSESSMENT_RESULT);
  localStorage.removeItem(WIDGET_DEPRESSION_ASSESSMENT_RESULT);
  localStorage.removeItem(WIDGET_BIPOLAR_ASSESSMENT_RESULT);
};

export const getStaticFilePath = (source: string) => {
  return `${MfeConfiguration.url}${source}`;
};

export const getWidgetLSKey = (condition: string) => {
  const map = new Map();
  map.set(ANXIETY_ASSESSMENT_RESULT, WIDGET_ANXIETY_ASSESSMENT_RESULT);
  map.set(DEPRESSION_ASSESSMENT_RESULT, WIDGET_DEPRESSION_ASSESSMENT_RESULT);
  map.set(BIPOLAR_ASSESSMENT_RESULT, WIDGET_BIPOLAR_ASSESSMENT_RESULT);

  return map.get(condition);
};
